'use client';

import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { InputField, InputFieldProps } from '../input-field/input-field';
import { Select, SelectProps } from '../select/select';

export type StateFieldProps = (SelectProps & InputFieldProps) & {
  isUS?: boolean;
};

export const StateField: React.FC<StateFieldProps> = ({
  isUS = true,
  ...fieldProps
}) => {
  const { name } = fieldProps;
  const { setValue, getValues, clearErrors } = useFormContext();
  // Track the state values for country changes
  const [initialLoad, setInitialLoad] = useState(true);
  const [prevState, setPrevState] = useState(null);

  useEffect(() => {
    setInitialLoad(false);
  }, []);

  useEffect(() => {
    if (!initialLoad && name) {
      const currVal = getValues()[name];
      setValue(name, prevState);
      setPrevState(currVal);
      clearErrors(name);
    }
  }, [isUS]);

  if (isUS) {
    return <Select {...fieldProps} />;
  }

  return <InputField {...fieldProps} />;
};
